
import { useAuthStore } from '../../stores/auth';
import { useSession } from '../../stores/session';
import { showVuePopup } from '../../utils/showVuePopup';
import Profile from '../../popup/Profile.vue';
import WalletWithdraw from '../../popup/WalletWithdraw.vue';
import PromotionList from '../../popup/PromotionList.vue';
import Contact from '../../popup/Contact.vue';
import Login from '../../popup/Login.vue';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import Register from '../../popup/Register.vue';

export default {
	name: 'IndexSubMenu',
	setup() {

		const auth = useAuthStore();
		auth.hydrate();

		const session = useSession();

		const btnClickWalletDeposit = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-login-Mobile.webp)] bg-size-[120%_100%] md:bg-size-[100%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:deposit');
			await showVuePopup(WalletDeposit, {});
		}

		const btnClickWalletWithdraw = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-login-Mobile.webp)] bg-size-[120%_100%] md:bg-size-[100%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:withdraw');
			await showVuePopup(WalletWithdraw, {});
		}

		const btnClickRegister = async () => {
			await showVuePopup(Register, {}, {
				customClass: {
					popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-register.webp)] bg-size-[100%_100%] bg-center bg-transparent'
				}
			});
		}

		const btnClickContact = async () => {
			await showVuePopup(Contact, {}, {
				customClass: {
					closeButton: 'absolute top-0 right-0 size-8! -translate-y-1/3 translate-x-1/3 bg-gray-100 hover:bg-gray-300 shadow rounded-full justify-center! items-center!',
					popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-contact-02.webp)] bg-size-[100%_100%] bg-center bg-transparent',
					htmlContainer: 'min-h-[16rem]',
				}
			});
		}

		return {
			btnClickWalletDeposit,
			btnClickWalletWithdraw,
			btnClickRegister,
			btnClickContact,
		}
	}
}
